import { request } from '@/shared/api/request'

export const actCreate = (data) => {
	return request({ url: `safety/actN1/create`, method: 'POST', data: data })
}

export const sendActXml = (data) => {
	return request({ url: `safety/actN1/xml`, method: 'GET', params: data })
}

export const sendAct = (data) => {
	return request({ url: `safety/actN1/saveAndSend`, method: 'POST', data: data })
}

export const actRecall = (data) => {
	return request({ url: `safety/actN1/recall`, method: 'GET', params: data })
}